import React from 'react';
import keyBy from 'lodash/keyBy';
import { currentUserSelector } from 'app/selectors/AuthSelector';
import { getShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import PrivacySettingsButtonContainer from 'app/components/bibs/shared/ugc/PrivacySettingsButton';
import composeGlobalSuccessMessaging from './composeGlobalSuccessMessaging';

export default function composeUgcSuccessMessaging({ response, store, metadataId, type, updated }) {
  const options = {
    renderActionsButton: () => <PrivacySettingsButtonContainer metadataId={metadataId} />
  };
  if (type !== 'rating') options.values = { ugcType: type };

  let messageId = type === 'rating' ? 'success_rating_updated' : 'success_ugc_updated';
  if (!updated) {
    const userId = currentUserSelector(store.getState()).get('id');
    const shelfItem = keyBy(response.entities.shelves[userId], d => d.metadataId);
    const existingShelfItem = !!getShelvesForCurrentUser(store.getState()).get(metadataId);
    const shelfKey = existingShelfItem ? 'shelf_existing' : 'shelf_added';
    const privateItemKey = shelfItem[metadataId].privateItem ? 'private' : 'public';
    const action = type === 'rating' ? 'rating' : 'ugc';
    messageId = `success_${action}_${shelfKey}_${privateItemKey}`;
  }
  return composeGlobalSuccessMessaging(messageId, options);
}
